module.exports = "https://cdn.hellotech.com/client-assets/simpliSafepkg__wide_2418eec1a2282d63da9d2d342430b0f6.jpg";